// Email Check
document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('#check_status_input');
  const emailInput = form?.querySelector('#check_status_form_email');
  const submitButton = form?.querySelector('#check_status_button');

  if (!form || !emailInput || !submitButton) return;

  submitButton.addEventListener('click', (e) => {
    e.preventDefault();

    const email = emailInput.value.trim();

    axiosGetEmailInfo(email);
  });
});
